import React, { useMemo } from 'react'
import Dropdown from 'core/elements/dropdown'
import withProgress from 'core/components/progress/withProgress'
import useListAction from 'core/hooks/useListAction'
import { listUsers } from './new-actions'
import { useSelector } from 'react-redux'
import { usersSelector } from './selectors'
import GlobalDropdownWithSearch from 'core/elements/dropdown/GlobalDropdownWithSearch'

const AsyncDropdown = withProgress(Dropdown, { inline: true })

interface UsersPicklistProps {
  disabled?: boolean
  name?: string
  label?: string
  includeNoneOption?: boolean
  includeAllOption?: boolean
  compact?: boolean
  onChange: (value: string) => void
  value: string
  width?: number
  align?: 'left' | 'right'
  [key: string]: any
}

export default function UsersPicklist({
  disabled = false,
  name = 'user',
  label = 'User',
  includeNoneOption = false,
  includeAllOption = false,
  compact = true,
  onChange,
  value,
  width = 180,
  align = 'left',
  ...rest
}: UsersPicklistProps) {
  const { loading } = useListAction(listUsers)
  const users = useSelector(usersSelector)

  const items = useMemo(() => {
    const userOptions = users.map((user) => ({
      label: user.username || user.displayname,
      value: user.id,
    }))

    const result = []
    if (includeAllOption) {
      result.push({ label: 'All', value: 'all' })
    }
    if (includeNoneOption) {
      result.push({ label: '-- None --', value: '' })
    }
    return [...result, ...userOptions]
  }, [users, includeNoneOption, includeAllOption])

  return compact ? (
    <AsyncDropdown
      {...rest}
      name={name}
      label={label}
      compact={false}
      disabled={disabled}
      loading={loading}
      items={items}
      onChange={onChange}
    />
  ) : (
    <GlobalDropdownWithSearch
      {...rest}
      label={label}
      items={items}
      loading={loading}
      onChange={(item) => onChange(item.value)}
      value={value}
      showLabelOnTop
      align={align}
      disabled={disabled}
      width={width}
    />
  )
}
